export default "__VITE_ASSET__dd9530e0__"